import dynamic from 'next/dynamic';

export const AppSmallBanner = dynamic(() => import('./organisms/AppSmallBanner/index').then(mod => mod.AppSmallBanner));
export const OffersAppContainer = dynamic(() =>
  import('./organisms/OffersAppContainer/index').then(mod => mod.OffersAppContainer)
);

//export * from './organisms/OffersAppContainer';
